import styled from 'styled-components';

import { Body2, Caption, spacing, colors } from 'ui/theme';

export const Container = styled.div`
  display: flex;
`;

export const CampaignTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CampaignImg = styled.img`
  border: ${`${spacing.single} solid ${colors.grey15}`};
  margin-right: ${spacing.threeQuarter};
  border-radius: ${spacing.quarter};
`;

export const CampaignName = styled(Body2)`
  font-weight: bold;
  margin: 0;
`;

export const CampaignAnalysisTextContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${spacing.eighth}; ;
`;

export const CaptionSecondary = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const CampaignMessageHeader = styled(CaptionSecondary)`
  text-decoration: underline;
  text-decoration-style: dotted;
  margin-top: ${spacing.quarter};
  margin-right: ${spacing.single};
`;

export const CampaignMoodText = styled(CaptionSecondary)`
  margin-top: ${spacing.quarter};
`;

export const AiSparkleWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: ${colors.purple10};
  margin-right: ${spacing.eighth};
  padding: ${spacing.eighth};
`;
